import { ENDPOINTS } from '../consts';
import { AbstractApi } from '../../abstract-api';
import { GetSpecialismsResp } from '../types/specialism';

export class SpecialismApi extends AbstractApi {
  async getSpecialisms(): Promise<GetSpecialismsResp> {
    const axios = await this.axios();
    const { data } = await axios.get<GetSpecialismsResp>(ENDPOINTS.LEARNING.SPECIALISM.BASE);
    return data;
  }
}
